import { Volume } from '~/shared/types/api';
import { toaster } from '~/shared/utils/toaster';
import { DatafySwitchContextType } from '~/shared/context/DatafySwitchProvider';
import {
  canBeDatafied,
  canBeUnDatafied,
  isSwitchedOn,
  isSwitchDisabled,
} from '~/shared/utils/volumeHelpers';

export const baseUrl = `/api/v1/volumes`;

export { canBeDatafied, canBeUnDatafied, isSwitchedOn, isSwitchDisabled };

export function datafyErrorToast(
  volumeId: Volume['volumeId'],
  event: DatafySwitchContextType['datafySwitchVolumes'][number]['state']
) {
  return toaster({
    variant: 'error',
    title: `${event === 'datafying' ? 'Datafication' : 'Undatafication'} Error`,
    message: `Volume ${volumeId} has failed to ${event === 'datafying' ? 'Datafy' : 'Undatafy'}.`,
    toastId: volumeId,
    volumeId,
  });
}

export const optmisticSwitchingInterval = 20000;

export const isVolumeExcludedFromAutodatafy = (volume: Volume): boolean => {
  return volume.tags?.some(
    (tag) => tag.key === 'datafy:auto-datafy:exclude' && tag.value === 'true'
  );
};
